import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  init: () => {
    const siteFooterTop = document.querySelector(".site-footer-top");

    gsap.fromTo(
      siteFooterTop,
      {
        height: "10vw",
      },
      {
        height: 0,
        scrollTrigger: {
          trigger: siteFooterTop,
          markers: false,
          scrub: true,
          start: "top 70%",
          end: "top 50%",
        },
      },
    );
  },
};
